import { useTranslate } from "@refinedev/core";

export const useDiscountTypeOptions = () => {
  const translate = useTranslate();

  const getDiscountTypeOptions = () => [
    { value: "", label: translate("options.none") },
    { value: "discount", label: translate("options.discount_types.discount") },
    { value: "treat", label: translate("options.discount_types.treat") },
    { value: "buy_and_gain", label: translate("options.discount_types.buy_and_gain") }
  ];

  return { getDiscountTypeOptions };
};
